export const fetchTranslations = ({ language = "lv" }) =>
  import(`locales/${language}`).then((module) => {
    return module.default;
  });
